if (!customElements.get('slide-banner')) {
  customElements.define(
    'slide-banner',
    class SlideBanner extends HTMLElement {
      constructor() {
        super();
        this.swiperElm = this.querySelector('.swiper');
        this.delay = this.getAttribute('data-delay');
        this.insertScriptYoutube();
      }
      connectedCallback() {
        if (!this.hasSwiper) {
          this.initSlide(window.innerWidth <= 749);
        }
      }
      insertScriptYoutube() {
        const haveYoutube = this.querySelector('[data-type="youtube"]');
        if (haveYoutube && !document.querySelector('head script[src="https://www.youtube.com/iframe_api"]')) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';

          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      }

      initVideo(isMobileScreen, elm) {
        if (isMobileScreen && elm.querySelector('.video-mobile')) {
          elm.querySelector('.video-desktop').remove();
        } else {
          elm.querySelector('.video-mobile')?.remove();
        }
      }

      playVideo = (swiper) => {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const typeMedia = currentSlide.querySelector('[data-type]').getAttribute('data-type');
        switch (typeMedia) {
          case 'video':
            const video = currentSlide?.querySelector('video');
            if (video && window.getComputedStyle(this).display != 'none') {
              video.play();
            }
            break;
          case 'youtube':
            currentSlide.youtube.mute();
            currentSlide.youtube.playVideo();
            let reCallVideo = setInterval(() => {
              if (currentSlide.youtube.getPlayerState() == 1) {
                clearInterval(reCallVideo);
                return;
              }
              currentSlide.youtube.playVideo();
            }, 500);
            break;
          case 'vimeo':
            const vimeoIframe = currentSlide.querySelector('iframe');
            if (vimeoIframe) {
              let currVimeo = new Vimeo.Player(vimeoIframe);
              currVimeo.setCurrentTime(0);
              currVimeo.setVolume(0);
              currVimeo.play();
              let reCallVideo = setInterval(() => {
                currVimeo.getPaused().then(function (paused) {
                  if (!paused) {
                    clearInterval(reCallVideo);
                    return;
                  }
                });
                currVimeo.play();
              }, 500);
            }
            break;
        }
      };

      pauseVideo(swiper) {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const typeMedia = currentSlide.querySelector('[data-type]').getAttribute('data-type');
        switch (typeMedia) {
          case 'video':
            const video = currentSlide?.querySelector('video');
            if (video && window.getComputedStyle(this).display != 'none') {
              video.pause();
            }
            break;
          case 'youtube':
            currentSlide.youtube.pauseVideo();
            break;
          case 'vimeo':
            const vimeoIframe = currentSlide.querySelector('iframe');
            if (vimeoIframe) {
              let currVimeo = new Vimeo.Player(vimeoIframe);
              currVimeo.pause();
            }
            break;
        }
      }

      initSlide(isMobileScreen) {
        this.querySelectorAll('.swiper-slide').forEach((elm) => this.initVideo(isMobileScreen, elm));
        if (isMobileScreen) {
          new Swiper(this.swiperElm, {
            slidesPerView: 1,
            loop: true,
            preventInteractionOnTransition: true,
            watchOverflow: true,
            autoplay: {
              delay: this.delay,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: this.querySelector('.swiper-button-next'),
              prevEl: this.querySelector('.swiper-button-prev'),
            },
            on: {
              init: (swiper) => {
                this.playVideo(swiper);
              },
              beforeSlideChangeStart: (swiper) => {
                this.pauseVideo(swiper);
              },
              slideChangeTransitionEnd: (swiper) => {
                this.playVideo(swiper);
              },
            },
          });
        } else {
          new Swiper(this.swiperElm, {
            loop: true,
            slidesPerView: 1,
            speed: 500,
            effect: 'fade',
            fadeEffect: {
              crossFade: true,
            },
            navigation: {
              nextEl: this.querySelector('.swiper-button-next'),
              prevEl: this.querySelector('.swiper-button-prev'),
            },
            autoplay: {
              delay: this.delay,
              disableOnInteraction: false,
              waitForTransition: true,
            },
            watchOverflow: true,
            on: {
              init: (swiper) => {
                this.playVideo(swiper);
              },
              beforeSlideChangeStart: (swiper) => {
                this.pauseVideo(swiper);
              },
              slideChangeTransitionEnd: (swiper) => {
                this.playVideo(swiper);
              },
            },
          });
        }
        this.hasSwiper = true;
      }
    }
  );
}
